import { TextAreaField } from '@schuettflix/planum-react';
import React from 'react';
import { Controller, ControllerProps, useFormContext } from 'react-hook-form';

type TextBoxInputFieldValues = {
    [key: string]: string | null;
};

export type TextBoxFieldInputProps = Pick<
    ControllerProps<TextBoxInputFieldValues>,
    'name' | 'defaultValue' | 'disabled'
> & {
    className?: string;
    placeHolder?: string;
    label?: string;
    description?: string;
    onTextBoxChange?: (value: string | undefined) => void;
    rows?: number;
};

export const TextBoxFieldInput = React.forwardRef<HTMLTextAreaElement, TextBoxFieldInputProps>(
    ({ name, defaultValue, disabled, className, placeHolder, onTextBoxChange, label, description, rows }, _ref) => {
        const { control } = useFormContext<TextBoxInputFieldValues>();

        return (
            <Controller
                control={control}
                defaultValue={defaultValue ?? null}
                disabled={disabled}
                name={name}
                render={({ field: { onChange, value, ...field }, fieldState: error }) => {
                    return (
                        <TextAreaField
                            {...field}
                            label={label}
                            value={value ?? ''}
                            description={description}
                            placeholder={placeHolder}
                            onChange={e => {
                                const value = e.target.value;

                                onTextBoxChange?.(value);
                                onChange(value);
                            }}
                            error={error.error?.message}
                            className={className}
                            rows={rows}
                        />
                    );
                }}
            />
        );
    }
);
